module.exports = __webpack_public_path__ + "static/flag-03f420e9f98e4e400f44b8172a4719f7.svg";